import { render, staticRenderFns } from "./law_record.vue?vue&type=template&id=43b552a6"
import script from "./law_record.vue?vue&type=script&lang=js"
export * from "./law_record.vue?vue&type=script&lang=js"
import style0 from "./law_record.vue?vue&type=style&index=0&id=43b552a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports